<template>
  <transition name="fade">
    <div id='modal' v-show="isShow">
      <div class="defult">
        <div class="title">{{modal.title}}</div>
        <div class="content" v-html="modal.content"></div>
        <div class="btns" v-if="modal.btnTitle.constructor.name === 'Array'">
          <div class="btn" v-for="(item, index) in modal.btnTitle" :key="index" @click="btnEvent(index)">
            {{modal.btnTitle[index]}}
          </div>
        </div>
        <div class="buttons" v-else @click="btnEvent">{{modal.btnTitle ? modal.btnTitle : '确定'}}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {};
  },
  computed: {
    isShow() {
      return this.$store.state.alert.show;
    },
    modal() {
      return this.$store.state.alert;
    }
  },
  beforeDestroy () {
    this.$store.commit('hideModal');
  },
  methods: {
    // 弹框按钮事件
    btnEvent (i) {
      // 防止连续点击应写到回调事件里
      this.close();
      if (this.modal.btnCallback && (this.modal.btnCallback.constructor.name === 'Array')) {
        return this.modal.btnCallback[i]();
      }
      if (this.modal.btnCallback && (i !== 0)) this.modal.btnCallback();
    },
    close() {
      this.$store.commit("hideModal");
    }
  }
};
</script>
<style lang='scss'>
#modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 110;
  .defult {
    width: 580px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    border-radius: 10px;
    text-align: center;
    .title{
      line-height:100px;
    }
    .content {
      font-size: 26px;
      color: #666;
      line-height: 1;
      padding: 0 50px 35px;
      line-height: 48px;
    }
    .buttons {
      background-color: #fff;
      line-height: 88px;
      height: 88px;
      font-size: 32px;
      color:#D72F1D;
      text-align: center;
      border-top:1px solid #e6e6e6;
    }
    .btns{
      border-top:1px solid #e6e6e6;
      display:flex;
      user-select: none;
      .btn{
        flex:1;
        font-size:32px;
        height:100px;
        line-height:100px;
        color:#D72F1D;
        &:nth-last-child(2) {
          color:#777777;
        }
        &:nth-child(2){
          border-left:1px solid #e6e6e6;
        }
      }
    }
  }
}
</style>
